import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/',
    scrollBehavior (to, from, savedPosition) {
        if(to.path === from.path) return
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 })
            }, 500)
        })
    },
    routes: [
        {
            path: '/',
            component: () => import('./pages/index.vue'),
            children: [
                {
                    path: '/',
                    name: 'indexPage',
                    meta: {
                        title: '壁虎看看',
                        keepAlive: true,
                        unGoHome: true,
                        shareTitle: '壁虎看看官网 - 快手短视频直播电商工具与数据服务平台',
                        shareDesc: '让您的快手业务裂变式增长'
                    },
                    component: () => import('./pages/index/index.vue')
                },
                {
                    path: '/zhaihehe',
                    name: 'zhaihehe',
                    meta: {
                        title: '今日网红·壁虎看看',
                        keepAlive: true,
                        unGoHome: true,
                        shareTitle: '壁虎看看官网 - 快手短视频直播电商工具与数据服务平台',
                        shareDesc: '让您的快手业务裂变式增长'
                    },
                    component: () => import('./pages/index/index.vue')
                },
                {
                    path: '/carrierList',
                    name: 'carrierList',
                    component: () => import('./pages/carrierList/index.vue'),
                    children: [
                        {
                            path: 'live',
                            name: 'carrierListLive',
                            meta: {
                                title: '壁虎看看-直播带货榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手短视频直播带货成交量成交额排行榜 - 壁虎看看',
                                shareDesc: '数据表明，这些主播人气最高，不服来战'
                            },
                            component: () => import('./pages/carrierList/live/index.vue')
                        },
                        {
                            path: 'commodity',
                            name: 'carrierListCommodity',
                            meta: {
                                title: '壁虎看看-热销商品榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手短视频直播带货热销商品排行榜 - 壁虎看看',
                                shareDesc: '又有新人在快手上卖出了几百万的货，快来勾搭他们'
                            },
                            component: () => import('./pages/carrierList/commodity/index.vue')
                        },
                        {
                            path: 'liveSelf',
                            name: 'carrierListLiveSelf',
                            meta: {
                                title: '壁虎看看-品牌自播带货榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手短视频直播带货成交量成交额排行榜 - 壁虎看看',
                                shareDesc: '数据表明，这些品牌商气最高，不服来战'
                            },
                            component: () => import('./pages/carrierList/liveSelf/index.vue')
                        },
                        {
                            path: 'gift',
                            name: 'carrierListGift',
                            meta: {
                                title: '壁虎看看-礼物收入榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手主播达人礼物收入排行榜 - 壁虎看看',
                                shareDesc: '每天有这些主播一场直播收入几百万，壕无人性'
                            },
                            component: () => import('./pages/carrierList/gift/index.vue')
                        },
                        {
                            path: 'giftGiving',
                            name: 'carrierListGiftGiving',
                            meta: {
                                title: '壁虎看看-土豪送礼榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手土豪送礼排行榜,快手电商挂榜排行榜 - 壁虎看看',
                                shareDesc: '这些快手土豪打赏这么多钱图啥呢，点开瞧一瞧吧'
                            },
                            component: () => import('./pages/carrierList/giftGiving/index.vue')
                        },
                        {
                            path: 'popularity',
                            name: 'carrierListPopularity',
                            meta: {
                                title: '壁虎看看-直播人气榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手直播人气、直播在线人数排行榜 - 壁虎看看',
                                shareDesc: '数据表明，这些主播人气最高，不服来战'
                            },
                            component: () => import('./pages/carrierList/popularity/index.vue')
                        },
                        {
                            path: 'fans',
                            name: 'carrierListFans',
                            meta: {
                                title: '壁虎看看-达人粉丝榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手粉丝达人榜，快手全网粉丝数量排行榜 - 壁虎看看',
                                shareDesc: '看看你关注的网红粉丝数量在快手到底排多少名'
                            },
                            component: () => import('./pages/carrierList/fans/index.vue')
                        },
                        {
                            path: 'addFans',
                            name: 'carrierListaddFans',
                            meta: {
                                title: '壁虎看看-达人涨粉榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手达人涨粉榜，快手全网涨粉数量排行榜 - 壁虎看看',
                                shareDesc: '看看你关注的网红粉丝涨粉在快手到底排多少名'
                            },
                            component: () => import('./pages/carrierList/addFans/index.vue')
                        },
                        {
                            path: 'liveFlow',
                            name: 'carrierListliveFlow',
                            meta: {
                                title: '壁虎看看-直播流量榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '快手直播流量榜 - 壁虎看看',
                                shareDesc: '快手直播流量榜 - 壁虎看看'
                            },
                            component: () => import('./pages/carrierList/liveFlow/index.vue')
                        },
                        {
                            path: 'liveTime',
                            name: 'carrierListliveTime',
                            meta: {
                                title: '壁虎看看-直播时长榜',
                                keepAlive: true,
                                unGoHome: true,
                                shareTitle: '直播时长榜 - 壁虎看看',
                                shareDesc: '直播时长榜 - 壁虎看看'
                            },
                            component: () => import('./pages/carrierList/liveTime/index.vue')
                        },
                    ]
                },
                {
                    path: '/testIdentity',
                    name: 'testIdentity',
                    meta: {
                        unGoHome: true,
                        title: '测试',
                        shareTitle: '测试'
                    },
                    component: () => import('./pages/testIdentity.vue')
                },

                {
                    path: '/my',
                    name: 'my',
                    meta: {
                        unGoHome: true,
                        keepAlive: true,
                        title: '个人中心',
                        shareTitle: '我的主页'
                    },
                    component: () => import('./pages/my/index.vue')
                },

                {
                    path: '/monitorList',
                    name: 'indexMonitorList',
                    meta: {
                        unGoHome: true,
                        title: '我的监控',
                        shareTitle: '我监控的达人 - 壁虎看看'
                    },
                    component: () => import('./pages/monitorList/index.vue')
                }
            ]
        },
        {
            path: '/banned',
            name: 'banned',
            meta: {title: '壁虎看看',},
            component: () => import('./pages/banned')
        },
        // {
        //   path: '/organizeActivity/doubleEleven',
        //   name: 'organizeActivityDoubleEleven',
        //   meta: { title: '壁虎看看-特惠双十一' },
        //   component: () => import('./pages/organizeActivity/doubleEleven.vue')
        // },
        {
            path: '/organizeActivity/newYearIsDay',
            name: 'organizeActivityNewYearIsDay',
            meta: { title: '壁虎看看-双旦同庆&礼遇新年' },
            component: () => import('./pages/organizeActivity/newYearIsDay.vue')
        },
        {
            path: '/shop/ranking',
            name: 'shopRanking',
            meta: { title: '壁虎看看-店铺排行榜' },
            component: () => import('./pages/shop/ranking.vue')
        },
        {
            path: '/shop/:id',
            name: 'shopInfo',
            meta: { title: '壁虎看看-店铺详情' },
            component: () => import('./pages/shop/_id.vue')
        },
        {
            path: '/share/live',
            name: 'shareLive',
            meta: { title: '壁虎看看-直播带货榜', unGoHome: true },
            component: () => import('./pages/share/live.vue')
        },
        {
            path: '/share/brand',
            name: 'shareLive',
            meta: { title: '壁虎看看-品牌分享榜', unGoHome: true },
            component: () => import('./pages/share/brand.vue')
        },
        {
            path: '/anchor/:id',
            name: 'anchorInfo',
            meta: {
                title: '壁虎看看-达人详情'
                // shareTitle: `${this.info.name} 的详细粉丝画像与直播分析和电商带货能力评估`,
            },
            component: () => import('./pages/anchor/_id/index.vue')
        },
        {
            path: '/information',
            name: 'information',
            meta: {
                title: '个人中心',
                shareTitle: '我的主页'
            },
            component: () => import('./pages/information/index.vue')
        },
        {
            path: '/information/completeInfo',
            name: 'informationCompleteInfo',
            meta: {
                title: '完善信息',
                shareTitle: '我的主页'
            },
            component: () => import('./pages/information/completeInfo.vue')
        },
        {
            path: '/information/compact',
            name: 'informationCompact',
            meta: {
                title: '用户协议',
                shareTitle: '我的主页'
            },
            component: () => import('./pages/information/compact.vue')
        },
        {
            path: '/goods/:id',
            name: 'goodsInfo',
            meta: {
                title: '商品详情'
                // shareTitle: `${this.info.commodity} 的销售趋势,关联达人,关联直播,销售构成 - 壁虎看看`,
            },
            component: () => import('./pages/goods/_id/index.vue')
        },
        {
            path: '/live/:anchorId/:id',
            name: 'liveInfo',
            meta: {
                title: '壁虎看看-直播详情'
                // shareTitle: `${this.info.commodity} 的销售趋势,关联达人,关联直播,销售构成 - 壁虎看看`,
            },
            component: () => import('./pages/live/_id/index.vue')
        },
        {
            path: '/live/:anchorId/:id/share',
            name: 'liveInfoShare',
            meta: {
                title: '直播分享',
                unGoHome: true
            },
            component: () => import('./pages/live/_id/share/index.vue')
        },
        {
            path: '/live/:anchorId/:id/card',
            name: 'liveInfoCard',
            meta: {
                title: '直播卡片',
                unGoHome: true
            },
            component: () => import('./pages/live/_id/Card.vue')
        },
        {
            path: '/dredgeVip',
            name: 'dredgeVip',
            component: () => import('./pages/dredgeVip/index.vue')
        },
        {
            path: '/free',
            name: 'free',
            meta: {
                title: '限免数据'
            },
            component: () => import('./pages/free/index.vue')
        },
        {
            path: '/platform/introduce',
            name: 'platform-introduce',
            meta: {
                title: '壁虎看看',
                unGoHome: true,
                unCollection: true
            },
            component: () => import('./pages/platform/introduce/index.vue')
        },
        {
            path: '/search',
            name: 'search',
            meta: {
                title: '搜索',
                shareTitle: '找主播 - 快手主播达人多维度精细化搜索 - 壁虎看看',
                shareDesc: '根据带货领域,达人条件,直播条件,直播与否,带货情况等维度来精细化搜索达人',
                keepAlive: true
            },
            component: () => import('./pages/search/index.vue')
        },
        {
            path: '/collection',
            name: 'collection',
            meta: {
                title: '我的收藏',
                shareTitle: '找主播 - 快手主播达人多维度精细化搜索 - 壁虎看看',
                shareDesc: '根据带货领域,达人条件,直播条件,直播与否,带货情况等维度来精细化搜索达人',
                keepAlive: true
            },
            component: () => import('./pages/collection/index.vue')
        },
        {
            path: '/zr',
            name: 'zr',
            meta: {
                title: '壁虎找人助手',
                shareTitle: '找主播 - 快手主播达人多维度精细化搜索 - 壁虎看看',
                shareDesc: '根据带货领域,达人条件,直播条件,直播与否,带货情况等维度来精细化搜索达人',
                unGoHome: true
            },
            component: () => import('./pages/zr/index.vue')
        },
        {
            path: '/zr/result',
            name: 'zr-result',
            meta: {
                title: '壁虎找人助手',
                shareTitle: '找主播 - 快手主播达人多维度精细化搜索 - 壁虎看看',
                shareDesc: '根据带货领域,达人条件,直播条件,直播与否,带货情况等维度来精细化搜索达人'
            },
            component: () => import('./pages/zr/result/index.vue')
        },
        {
            path: '/gb',
            name: 'result',
            meta: {
                title: '壁虎挂榜助手',
                unGoHome: true,
                keepAlive: true,
                shareTitle: '壁虎挂榜助手',
                shareDesc: '根据带货领域,达人条件,直播条件,直播与否,带货情况等维度来精细化搜索达人'
            },
            component: () => import('./pages/gb/index.vue')
        },
        {
            path: '/gb/anchor/:id',
            name: 'gbAnchorId',
            meta: {
                title: '壁虎挂榜助手',
                shareTitle: '壁虎挂榜助手',
                shareDesc: '根据带货领域,达人条件,直播条件,直播与否,带货情况等维度来精细化搜索达人'
            },
            component: () => import('./pages/gb/anchor/_id/index.vue')
        },
        {
            path: '/gb/search',
            name: 'gbSearch',
            meta: {
                title: '壁虎挂榜助手',
                shareTitle: '壁虎挂榜助手',
                shareDesc: '根据带货领域,达人条件,直播条件,直播与否,带货情况等维度来精细化搜索达人'
            },
            component: () => import('./pages/gb/search/index.vue')
        },
        {
            path: '/addGoods',
            name: 'addGoods',
            meta: {
                title: '商品助手',
                keepAlive: true,
                unGoHome: true,
                unCollection: true,
                wxNumber: 'bihu936',
                operationsEventsId: 7
            },
            component: () => import('./pages/addGoods/index.vue')
        },
        {
            path: '/BaojiaBD',
            name: 'BaojiaBD',
            meta: {
                title: '好货提交',
                keepAlive: true,
                unGoHome: true,
                unCollection: true,
                wxNumber: 'BaojiaBD',
                operationsEventsId: 8
            },
            component: () => import('./pages/addGoods/index.vue')
        },
        {
            path: '/course',
            name: 'course',
            meta: { unGoHome: true, unCollection: true },
            component: () => import('./pages/course/index.vue')
        },
        {
            path: '/webView',
            name: 'webView',
            meta: {
                title: '壁虎看看',
                shareTitle: '壁虎看看',
                unGoHome: true,
                unCollection: true
            },
            component: () => import('./pages/webView/index.vue')
        },
        {
            path: '/liveNow',
            name: 'liveNow',
            meta: {
                title: '壁虎看看-实时直播',
                shareTitle: '壁虎看看-实时直播'
            },
            component: () => import('./pages/liveNow/index.vue')
        },
        {
            path: '/Delivery',
            name: 'Delivery',
            meta: {
                title: '壁虎看看-带货视频榜',
                shareTitle: '壁虎看看-带货视频榜',
            },
            component: () => import('./pages/Delivery/index.vue'),
            children:[
                {
                    path: 'videoCommodity',
                    name: 'DeliveryvideoCommodity',
                    meta: {
                        title: '壁虎看看-带货视频榜',
                        shareTitle: '壁虎看看-带货视频榜',
                        shareDesc: '壁虎看看-带货视频榜',
                        keepAlive: true,
                        unGoHome: true,
                    },
                    component: () => import('./pages/Delivery/videoCommodity/index.vue'),
                },
                {
                    path: 'playlet',
                    name: 'Deliveryplaylet',
                    meta: {
                        title: '壁虎看看-短剧达人榜',
                        keepAlive: true,
                        unGoHome: true,
                        shareTitle: '短剧达人榜 - 壁虎看看',
                        shareDesc: '短剧达人榜 - 壁虎看看'
                    },
                    component: () => import('./pages/Delivery/playlet/index.vue')
                },
                {
                    path: 'VideoCommunication',
                    name: 'DeliveryVideoCommunication',
                    meta: {
                        title: '壁虎看看-视频传播榜',
                        keepAlive: true,
                        unGoHome: true,
                        shareTitle: '视频传播榜 - 壁虎看看',
                        shareDesc: '视频传播榜 - 壁虎看看'
                    },
                    component: () => import('./pages/Delivery/VideoCommunication/index.vue')
                },
                {
                    path: 'VideoInteraction',
                    name: 'DeliveryVideoInteraction',
                    meta: {
                        title: '壁虎看看-视频互动榜',
                        keepAlive: true,
                        unGoHome: true,
                        shareTitle: '视频互动榜 - 壁虎看看',
                        shareDesc: '视频互动榜 - 壁虎看看'
                    },
                    component: () => import('./pages/Delivery/VideoInteraction/index.vue')
                },
                {
                    path: 'topic',
                    name: 'Deliverytopic',
                    meta: {
                        title: '壁虎看看-快手话题榜',
                        keepAlive: true,
                        unGoHome: true,
                        shareTitle: '快手话题榜 - 壁虎看看',
                        shareDesc: '快手话题榜 - 壁虎看看'
                    },
                    component: () => import('./pages/Delivery/topic/index.vue')
                },
            ]
        },
        {
            path: '/more',
            name: 'more',
            meta: {
                title: '壁虎看看-更多服务',
                shareTitle: '壁虎看看-更多服务',
            },
            component: () => import('./pages/more/index.vue'),
        },
        {
            path: '/record',
            name: 'record',
            meta: {
                title: '直播录制工具',
                keepAlive: true,
                unGoHome: true,
                shareTitle: '壁虎看看官网 - 直播录制工具',
            },
            component: () => import('./pages/record/index.vue')
        },
        {
            path: '/openPlatform',
            name: 'openPlatform',
            meta: {
                title: '数据开放平台',
                keepAlive: true,
                unGoHome: true,
                shareTitle: '壁虎看看官网 - 数据开放平台',
            },
            component: () => import('./pages/openPlatform/index.vue')
        },
        {
            path: '/dataScreen',
            name: 'dataScreen',
            meta: {
                title: '定制数据大屏',
                keepAlive: true,
                unGoHome: true,
                shareTitle: '壁虎看看官网 - 定制数据大屏',
            },
            component: () => import('./pages/dataScreen/index.vue')
        },
        {
            path: '/brainPower',
            name: 'brainPower',
            meta: {
                title: '快手小店智能客服',
                keepAlive: true,
                unGoHome: true,
                shareTitle: '壁虎看看官网 - 快手小店智能客服',
            },
            component: () => import('./pages/brainPower/index.vue')
        },//brandPromotion
        {
            path: '/brandPromotion',
            name: 'brandPromotion',
            meta: {
                title: '品牌推广服务',
                keepAlive: true,
                unGoHome: true,
                shareTitle: '壁虎看看官网 - 品牌推广服务',
            },
            component: () => import('./pages/brandPromotion/index.vue')
        },
        {
            path: '/activePage',
            name: 'activePage',
            meta: {
                title: '活动中心-壁虎看看',
                shareTitle: '活动中心—壁虎看看',
            },
            component: () => import('./pages/activePage/index.vue')
        },
        {
            path: '/carrierListBrand',
            name: 'carrierListBrand',
            meta: {
                title: '壁虎看看-热销品牌'
            },
            component: () => import('./pages/carrierList/brand/index.vue')
        },
        {
            path: '/brand/search',
            name: 'brandSearch',
            meta: { title: '壁虎看看-品牌搜索', keepAlive: true },
            component: () => import('@/pages/brand/search/index')
        },
        {
            path: '/brand/:id',
            name: 'brandid',
            meta: { title: '壁虎看看-品牌详情' },
            component: () => import('./pages/brand/_id/index.vue')
        },
        {
            path: '/activity',
            name: 'activity',
            meta: {
                title: '宣传海报',
                unGoHome: true
            },
            component: () => import('./pages/activity/act-preview.vue')
        },
        {
            path: '/activity/getting',
            name: 'activityGetting',
            meta: {
                title: '领取页面',
                unGoHome: true
            },
            component: () => import('./pages/activity/act-getting.vue')
        },
        {
            path: '/activity/got',
            name: 'activityGot',
            meta: {
                title: '领取成功',
                unGoHome: true
            },
            component: () => import('./pages/activity/act-got.vue')
        },
        {
            path: '/activity/fail',
            name: 'activityFail',
            meta: {
                title: '领取失败',
                unGoHome: true
            },
            component: () => import('./pages/activity/act-fail.vue')
        },
        {
            path: '/addInclusion',
            name: 'addInclusion',
            meta: {
                title: '添加收录',
                unGoHome: true
            },
            component: () => import('./pages/addInclusion/index.vue')
        },
        {
            path: '/packagePay/:id',
            name: 'packagePay',
            meta: { title: '壁虎看看-套餐包' },
            component: () => import('./pages/packagePay/_id.vue')
        },
        {
            path: '/largeMarket',
            name: 'largeMarket',
            redirect: '/largeMarket/stream',
            component: () => import('pages/largeMarket/index.vue'),
            children: [
                {
                    path: '/largeMarket/stream',
                    name: 'largeMarketStream',
                    meta: {
                        title: '壁虎看看-直播流量大盘',
                        keepAlive: true,
                        unGoHome: false,
                        shareTitle: '快手粉丝达人榜，快手全网粉丝数量排行榜 - 壁虎看看',
                        shareDesc: '壁虎看看-直播流量大盘'
                    },
                    component: () => import('./pages/largeMarket/stream/index.vue')
                },
                {
                    path: '/largeMarket/goods',
                    name: 'largeMarketGoods',
                    meta: {
                        title: '壁虎看看-直播流量大盘',
                        keepAlive: true,
                        unGoHome: false,
                        shareTitle: '快手粉丝达人榜，快手全网粉丝数量排行榜 - 壁虎看看',
                        shareDesc: '壁虎看看-直播流量大盘'
                    },
                    component: () => import('./pages/largeMarket/goods/index.vue')
                }
            ]
        },
    ]
});

export default router 